// Modellväljaren för iPhone-skalen. Ett tryck på en serie visar seriens modeller och väljer samma
// typ som förut om den finns, till exempel Pro i 15 till Pro i 16, annars seriens första modell.
// Valet går via temats egen radioknapp, så variant, pris och bild uppdateras som vanligt.
if (!window.mxSerie) {
  window.mxSerie = true;
  document.addEventListener('click', (event) => {
    const knapp = event.target.closest('.mx-serie__knapp');
    if (!knapp) return;
    const form = knapp.closest('form');
    const fieldset = form && form.querySelector('.mx-modell');
    if (!fieldset) return;
    const serie = knapp.dataset.mxSerie;
    if (fieldset.dataset.mxAktivSerie === serie) return;

    form.querySelectorAll('.mx-serie__knapp').forEach((k) => k.setAttribute('aria-pressed', String(k === knapp)));
    fieldset.dataset.mxAktivSerie = serie;

    const valdTyp = (fieldset.querySelector('input:checked')?.value || '').split(' ').slice(2).join(' ');
    const iSerien = [...fieldset.querySelectorAll(`label[data-mx-serie="${serie}"] input`)];
    const typ = (input) => input.value.split(' ').slice(2).join(' ');
    const nasta = iSerien.find((input) => typ(input) === valdTyp) || iSerien[0];
    if (nasta && !nasta.checked) nasta.click();
  });
}
